import React from 'react'
import { House, ChevronRight } from 'lucide-react'

export const BREADCRUMB_CSS = `
  .ljn-breadcrumb {
    display: flex; align-items: center; flex-wrap: wrap;
    gap: 4px 2px;
    list-style: none;
    font-family: var(--font-sans);
    font-size: 11px; letter-spacing: 0.08em; text-transform: uppercase;
  }
  .ljn-breadcrumb__item {
    display: flex; align-items: center; gap: 2px;
  }
  .ljn-breadcrumb__link {
    color: var(--color-slate);
    text-decoration: none;
    transition: color 0.18s;
  }
  .ljn-breadcrumb__link:hover { color: var(--color-teal); }
  .ljn-breadcrumb__sep {
    color: var(--color-slate);
    display: flex; align-items: center;
  }
  .ljn-breadcrumb__current {
    color: var(--color-charcoal);
    font-weight: 500;
  }
`

// items: [{ label, url }] — last item (url=null) = current page
export default function Breadcrumb({ items = [], className = '' }) {
  if (!items.length) return null
  const crumbs = Array.isArray(items) ? [...items].filter(Boolean) : []

  return (
    <nav aria-label="Breadcrumb">
      <ol className={`ljn-breadcrumb ${className}`}>
        {crumbs.map((crumb, i) => {
          const isLast = i === crumbs.length - 1
          return (
            <li key={i} className="ljn-breadcrumb__item">
              {i > 0 && (
                <span className="ljn-breadcrumb__sep" aria-hidden>
                  <ChevronRight size={12} strokeWidth={1.5} />
                </span>
              )}
              {isLast || !crumb.url
                ? <span className="ljn-breadcrumb__current" aria-current="page" dangerouslySetInnerHTML={{ __html: crumb.label }} />
                : (
                  <a href={crumb.url} className="ljn-breadcrumb__link" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    {i === 0 && <House size={12} strokeWidth={1.5} />}
                    <span dangerouslySetInnerHTML={{ __html: crumb.label }} />
                  </a>
                )
              }
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
